import { render, staticRenderFns } from "./LoadingItem.vue?vue&type=template&id=19c4157c&scoped=true&lang=pug&"
var script = {}
import style0 from "./LoadingItem.vue?vue&type=style&index=0&id=19c4157c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4157c",
  null
  
)

export default component.exports